<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_bi3"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('shipmentCompany_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('shipmentCompany_add_button')"
          @click="funcAdd"
        >
          新增
        </el-button>
        <el-button
          v-if="getLimit('shipmentCompany_checkQuire_button') && isAdmin"
          @click="funcheckQuire"
        >
          设置必填项
        </el-button>
        <el-button
          v-if="getLimit('shipmentCompany_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      class="mytable-style"
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :cell-class-name="cellClassName"
      :show-footer="true"
      :footer-method="footerMethod"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortListChange"
    >
      <vxe-table-column type="checkbox" width="60" />
      <!-- 承运主体 -->
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="200"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 公司名称 -->
      <vxe-table-column>
        <vxe-table-column
          field="companyName"
          title="公司名称"
          min-width="200"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入公司名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 服务费率(%) -->
      <vxe-table-column v-if="isCtms">
        <vxe-table-column
          field="taxPoint"
          title="服务费率(%)"
          min-width="185"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPointStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPointEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- 余额 -->
      <vxe-table-column>
        <vxe-table-column
          field="amount"
          title="余额"
          min-width="185"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.amountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.amountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>

      <!-- 油气优惠标准 -->
      <vxe-table-column>
        <vxe-table-column
          field="discountPoint"
          title="油气优惠比例(%)"
          min-width="185"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.discountPointStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.discountPointEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- 联系人 -->
      <vxe-table-column>
        <vxe-table-column field="userName" title="联系人" min-width="100" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userName"
            placeholder="请输入联系人"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 联系方式 -->
      <vxe-table-column>
        <vxe-table-column field="phone" title="联系方式" min-width="130" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入联系方式"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 平台服务经理姓名 -->
      <vxe-table-column>
        <vxe-table-column
          field="salesmanName"
          title="平台服务经理"
          min-width="130"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.salesmanName"
            placeholder="请输入平台服务经理"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 渠道执行费率(%)：所属渠道调价生效时同步刷新 -->
      <vxe-table-column>
        <vxe-table-column
          field="channelExecRate"
          title="渠道执行费率(%)"
          min-width="185"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.channelExecRateStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.channelExecRateEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- 平台服务经理号码 -->
      <vxe-table-column>
        <vxe-table-column
          field="salesmanPhone"
          title="平台服务经理号码"
          min-width="130"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.salesmanPhone"
            placeholder="请输入平台服务经理号码"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 审核状态 -->
      <!-- <vxe-table-column>
        <vxe-table-column
          field="authStatus"
          title="审核状态"
          :formatter="formatterAuthStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in authStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column> -->

      <vxe-table-column title="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              getLimit('shipment_rate_edit_button') &&
                scope.row.mainAccountFlag === 1
            "
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="changeRateEdit(scope.row)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>

          <!-- 查看全部 -->
          <el-tooltip
            class="item"
            effect="dark"
            content="全部费率"
            placement="top"
          >
            <vxe-button type="text" @click="showAllRate(scope.row)">
              <img
                style="width:14px;height:14px;"
                src="@/assets/icon/all.png"
                alt=""
              />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="提现" placement="top">
            <vxe-button type="text" @click="changeWithdraw(scope.row)">
              <img
                style="width:16px;height:16px;"
                src="@/assets/icon/tx.png"
                alt=""
              />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="操作日志"
            placement="top"
          >
            <vxe-button type="text" @click="openLog(scope.row)">
              <i class="el-icon-notebook-2" />
            </vxe-button>
          </el-tooltip>
          <!-- <el-tooltip
            v-if="getLimit('shipmentCompany_delete_button')"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('shipmentCompany_DIS_button') &&
                showApplyDisBtn(scope.row)
            "
            class="item"
            effect="dark"
            content="申请DIS"
            placement="top"
          >
            <vxe-button type="text" @click="funcApply(scope.row.partyCode)">
              <i class="el-icon-connection" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.authStatus == 3 && !scope.row.memNum"
            class="item"
            effect="dark"
            content="申请虚拟账号"
            placement="top"
          >
            <vxe-button type="text" @click="funcDobiz(scope.row.code)">
              <i class="el-icon-connection" />
            </vxe-button>
          </el-tooltip> -->
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />

    <!-- 编辑费率 -->
    <vxe-modal
      v-if="showRateEdit"
      v-model="showRateEdit"
      title="编辑费率"
      width="500"
      resize
    >
      <editBranch
        :branch-info="branchInfo"
        @clsoeModel="showRateEdit = false"
        @updateList="updateList"
      />
    </vxe-modal>
    <!-- 全部费率 -->
    <vxe-modal
      v-if="showRateAll"
      v-model="showRateAll"
      title="全部费率"
      width="500"
      height="400"
      resize
    >
      <allRate :branch-info="branchInfo" @updateList="updateList" />
    </vxe-modal>
    <!-- 操作日志 -->
    <vxe-modal
      v-if="isShowLog"
      v-model="isShowLog"
      title="操作日志"
      width="500"
      height="400"
      resize
    >
      <div v-if="isShowLog">
        <el-timeline v-if="logList.length" style="margin-top: 20px;">
          <el-timeline-item
            v-for="(activity, index) in logList"
            :key="index"
            :timestamp="activity.timestamp"
          >
            {{ activity.title }}
            <div style="color: #999;font-size: 12px;">
              {{ activity.operTime }}
            </div>
          </el-timeline-item>
        </el-timeline>
        <div v-else style="text-align: center;margin-top: 20px;">
          暂无操作日志
        </div>
      </div>
    </vxe-modal>
    <!-- 提现弹窗 -->
    <vxe-modal
      v-if="showWithdraw"
      v-model="showWithdraw"
      title="提现"
      width="500"
      height="350"
      resize
      @close="
        jointLineNum = null;
        outAmount = null;
      "
    >
      <div>
        <div class="widthDraw_box">
          <div class="widthDraw_box_item">
            公司名称:
          </div>
          <el-input
            v-model="widthDrawInfo.companyName"
            placeholder="请输入公司名称"
            :disabled="true"
          />
        </div>
        <div class="widthDraw_box">
          <div class="widthDraw_box_item">
            联行号:
          </div>
          <el-input v-model="jointLineNum" placeholder="请输入联行号" />
        </div>
        <div class="widthDraw_box">
          <div class="widthDraw_box_item">
            提现金额:
          </div>
          <el-input v-model="outAmount" placeholder="请输入提现金额" />
        </div>
      </div>

      <div class="widthDraw_sure_btn">
        <el-button
          :loading="withDrawLoading"
          type="primary"
          @click="sureWithdraw"
          >提现</el-button
        >
      </div>
    </vxe-modal>
  </div>
</template>
<script>
import allRate from "./components/allRate.vue";
import editBranch from "./components/editBranch.vue";
import { getRole } from "@/utils/getRole";
import {
  getShipperList,
  delShipperInfo,
  maYiBlockChain,
  syncMemName,
  shipmentServiceFee,
  operlogList,
  updateTaxFee,
  switchingShipmentServiceFee,
  outbalance
} from "@/api/shipment";
export default {
  name: "ShipmentCompanyManage",
  components: {
    allRate,
    editBranch
  },
  data() {
    return {
      logList: [],
      activities: [
        {
          content: "活动按期开始",
          timestamp: "2018-04-15"
        },
        {
          content: "通过审核",
          timestamp: "2018-04-13"
        },
        {
          content: "创建成功",
          timestamp: "2018-04-11"
        }
      ],
      withDrawLoading: false,
      exportObj: {
        exportUrl: "/ntocc-basic-api/shipment/exportShipment", //导出接口
        name: "企业托运人"
      },
      isCtms: true, //默认显示 同城系统时隐藏
      branch: this.$store.getters.branch,
      loading: false,
      tableData: [],
      listQuery: {
        // branchCode: "",
        // partyCode: "",
        // taxPoint: "",
        // bankName: "",
        // bankAccount: "",
        // memNum: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        exportType: 1
      },
      sumObject: {
        freezingAmount: 0,
        amount: 0,
        ensureFeeAmount: 0
      },
      // 审核状态
      authStatusList: [
        { label: "未审核", value: 0 },
        // { label: "审核中", value: 1 },
        { label: "审核驳回", value: 2 },
        { label: "审核通过", value: 3 }
      ],
      // 通用是否状态
      commonStatusList: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 是否admin
      isAdmin: false,
      showBranchModel: false,
      showRateAll: false,
      showRateEdit: false,
      branchInfo: null,
      showWithdraw: false,
      widthDrawInfo: null,
      jointLineNum: "",
      outAmount: null,
      isShowLog: false
      // 是否顶级机构
      // isTopBranch: false,
    };
  },
  computed: {
    branchList() {
      return this.$store.state.components.branchList;
    }
  },
  watch: {
    "$store.state.components.branchList": function() {
      this.$refs.xTable.updateData();
    },
    "$store.state.tagsView.cachedViews": function(cachedViews) {
      // 新增调回需要刷新数据
      if (!cachedViews.includes("ShipmentCompanyManage")) {
        let route = this.getRoute(this.$router.options.routes);
        route.meta.keepLive = false;
      }
    },
    "$route.query.needRefreshCompany": function(newVal, oldVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.RefreshList();
          let newQuery = JSON.parse(JSON.stringify(this.$route.query));
          delete newQuery.needRefreshCompany;
          this.$router.replace({ query: newQuery });
        });
      }
    }
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    this.isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.findList();
    this.isCtmsShow = getRole(); //获取登录用户登录的是否是同城系统
    let dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    this.platformDid = dataBranch.platformDid;
    if (
      dataBranch.partyGroupConfigCacheMap.MaYiBlockChainConfig_useMaYiBlockChain
    ) {
      this.openMaYiBlockChain =
        dataBranch.partyGroupConfigCacheMap
          .MaYiBlockChainConfig_useMaYiBlockChain.configValue == 1
          ? true
          : false;
    }
    // this.isTopBranch = dataBranch.level == 0;
  },
  methods: {
    getOperlogList(item) {
      let data = {
        reviewCode: item.code,
        businessType: 11
      };
      operlogList(data).then(response => {
        this.logList = response.data.records;
      });
    },
    sureWithdraw() {
      if (!this.jointLineNum) {
        this.$message.error("请输入联行号");
        return;
      }
      if (!this.outAmount) {
        this.$message.error("请输入提现金额");
        return;
      }
      this.$confirm(
        "确定提现" +
          this.outAmount +
          "元到" +
          this.widthDrawInfo.companyName +
          "?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        this.withDrawLoading = true;
        outbalance({
          code: this.widthDrawInfo.code,
          account: this.widthDrawInfo.bankAccount,
          accountName: this.widthDrawInfo.companyName,
          bankName: this.widthDrawInfo.bankName,
          jointLineNum: this.jointLineNum,
          outAmount: this.outAmount
        })
          .then(response => {
            this.$message.success("提现成功");
            this.showWithdraw = false;
            this.withDrawLoading = false;
            this.findList();
          })
          .catch(call => {
            this.withDrawLoading = false;
          });
      });
    },
    changeWithdraw(item) {
      console.log("changeWithdraw提现========", item);
      this.showWithdraw = true;
      this.widthDrawInfo = item;
    },
    openLog(item) {
      this.isShowLog = true;
      this.getOperlogList(item);
    },
    camelToUnderscore(str) {
      return str.replace(/([A-Z])/g, "_$1").toLowerCase();
    },
    sortListChange({ column, property, order }) {
      console.log("======???", property, order);
      if (order) {
        this.listQuery.sortField = this.camelToUnderscore(property);
        this.listQuery.sortType = order;
      } else {
        this.listQuery.sortField = "";
        this.listQuery.sortType = "";
      }
      this.findList();
    },
    // 编辑
    updateTaxFee() {},
    changeRateEdit(info) {
      this.branchInfo = info;
      this.showRateEdit = true;
    },
    showAllRate(info) {
      this.branchInfo = info;
      this.showRateAll = true;
    },
    // 刷新列表
    updateList() {
      this.showRateEdit = false;
      this.showBranchModel = false;
      this.findList();
    },

    getRoute(routerList) {
      var list = "";
      for (let item of routerList) {
        if (item.children) {
          let clist = this.getRoute(item.children);
          if (this.getRoute(item.children)) {
            return clist;
          }
        }
        if (item.name == "ShipmentCompanyManage") {
          list = item;
          return list;
        }
      }
      return list;
    },
    showApplyDisBtn(row) {
      if (!this.openMaYiBlockChain || this.isCtmsShow) {
        return false;
      }
      let hasDid = !(
        typeof this.platformDid == "undefined" || this.platformDid == ""
      );
      return (
        hasDid &&
        row.authStatus == 3 &&
        (row.szwlDid == null || row.szwlDid == "")
      );
    },
    findList() {
      return new Promise(resolve => {
        this.loading = true;
        shipmentServiceFee(this.listQuery).then(response => {
          resolve();
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item1 => item1.code === cellValue);
      return item ? item.groupName : "";
    },
    // 添加方法
    funcAdd() {
      this.$router.push({
        path: "/basicInfo/shipment/addShipmentCompanyForm",
        query: { company: "1", type: "add" }
      });
    },
    // 修改方法
    funcEdit(row) {
      this.$router.push({
        path: "/basicInfo/shipment/editShipmentCompanyForm",
        query: {
          code: row.code,
          partyCode: row.partyCode,
          company: "1",
          branchCode: row.branchCode
        }
      });
    },
    // 设置必填项
    funcheckQuire(row) {
      this.$router.push({
        path: "/basicInfo/shipment/requiredShipmentCompanyForm",
        query: { company: "1", checkQuire: true }
      });
    },
    // 详情
    funcDetail(row) {
      this.$router.push({
        path: "/basicInfo/shipment/infoShipmentCompanyForm",
        query: {
          code: row.code,
          partyCode: row.partyCode,
          company: "1",
          branchCode: row.branchCode
        }
      });
    },
    // 删除方法
    funcDelete(codes) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          delShipperInfo({ codes }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 申请DIS
    async funcApply(codes) {
      let response = await maYiBlockChain(codes);
      this.$message({ message: response.msg, type: "success" });
      this.findList();
    },
    // 创建虚拟账号方法
    funcDobiz(codes) {
      this.$confirm("确认需要创建光大虚拟账号吗？")
        .then(_ => {
          syncMemName({ code: codes }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 翻译审核状态
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusList.find(item1 => item1.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译通用是否状态
    formatterCommonStatus({ cellValue }) {
      const item = this.commonStatusList.find(
        item1 => item1.value === cellValue
      );
      return item ? item.label : "";
    },
    //提示标红
    cellClassName({ row, rowIndex, column, columnIndex }) {
      //身份证
      if (column.property === "idCardDueDate") {
        if (row.idcardDueWarn == 1) {
          return "col-red";
        }
      }
    },
    // 合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "amount") {
            return this.$XEUtils.sum(data, column.property);
          }
          /*          if (column.property === "ensureFee") {
              return "待定";
            }*/
          if (column.property === "ensureFeeAmount") {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    }
  }
};
</script>
<style scoped>
.widthDraw_sure_btn {
  width: 100%;
  text-align: center;
}
.widthDraw_box {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 30px;
}
.widthDraw_box_item {
  width: 110px;
  text-align: right;
  margin-right: 10px;
  font-weight: 600;
}
</style>
